import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from '../logger/global-logger.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class GlobalErrorHandlerService extends ErrorHandler {
    constructor(private loggerService: LoggerService) {
        super();
    }
    handleError(error) {
        if (error instanceof HttpErrorResponse) {
            console.error('There was an HTTP error.', error.message, 'Status code:', (<HttpErrorResponse>error).status);
        } else if (error instanceof TypeError) {
            console.error('There was a Type error.', error.message);
        } else if (error instanceof Error) {
            console.error('There was a general error.', error.message);
        } else {
            console.error('Nobody threw an error but something happened!', error);
        }
        super.handleError(error);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/core/auth/global-error-handler.service.ts